export default __webpack_public_path__ + "static/media/logoLoginRS.d5a0c372.png";